import { createInstance } from "@hackler/react-sdk"

const hackleSdkDebug = process.env.REACT_APP_HACKLE_DEBUG === "true"
export const hackleClient = createInstance(process.env.REACT_APP_HACKLE_SDK_KEY!, { debug: hackleSdkDebug })
